<section class="o-section">
  <div class="o-wrapper">
    <div class="o-layout">
      <div class="o-layout__item [ u-10/12@desktop u-push-1/12@desktop ]">

        <div class="hipaa-benefits-screen">
          <h1 class="hipaa-benefits-screen__title">
            {{ "HIPAA-CONSENT.pre_therapy_hipaa_full_sharing_benefits_description_text_1" | translate }}
          </h1>

          <div class="hipaa-benefits-screen__items">
            <!-- Personalized support -->
            <div class="hipaa-benefits-screen__item">
              <div class="hipaa-benefits-screen__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.087 21" fill="none" width="24" height="24">
                  <path d="M8.52174 0C5.83207 0 3.65217 2.17989 3.65217 4.86957C3.65217 7.55924 5.83207 9.73913 8.52174 9.73913C11.2114 9.73913 13.3913 7.55924 13.3913 4.86957C13.3913 2.17989 11.2114 0 8.52174 0ZM5.47826 4.86957C5.47826 3.18804 6.84022 1.82609 8.52174 1.82609C10.2033 1.82609 11.5652 3.18804 11.5652 4.86957C11.5652 6.55109 10.2033 7.91304 8.52174 7.91304C6.84022 7.91304 5.47826 6.55109 5.47826 4.86957ZM6.69565 11.5652C2.99783 11.5652 0 14.563 0 18.2609V18.5652C0 19.0712 0.407065 19.4783 0.913043 19.4783C1.41902 19.4783 1.82609 19.0712 1.82609 18.5652V18.2609C1.82609 15.5712 4.00598 13.3913 6.69565 13.3913H7.41848C7.57065 12.7141 7.86739 12.094 8.27446 11.5652H6.69565ZM11.9837 11.5652C10.4087 11.5652 9.13424 12.8435 9.13424 14.4147V14.5098C9.13424 16.9598 12.2538 19.581 13.7832 20.7223C14.0304 20.9049 14.3196 21 14.6125 21C14.9054 21 15.1946 20.9087 15.4418 20.7223C16.9674 19.5848 20.087 16.9598 20.087 14.5098V14.4147C20.087 12.8397 18.8087 11.5652 17.2413 11.5652C16.3283 11.5652 15.4685 12.0027 14.9321 12.7446L14.6125 13.1897L14.2929 12.7446C13.7565 12.0027 12.8967 11.5652 11.9837 11.5652Z" fill="#006DFF"/>
                </svg>
              </div>
              <div class="hipaa-benefits-screen__content">
                <h3 class="hipaa-benefits-screen__item-title">
                  {{ "HIPAA-CONSENT.pre_therapy_hipaa_full_sharing_benefits_title_2" | translate }}
                </h3>
                <p class="hipaa-benefits-screen__item-description">
                  {{ "HIPAA-CONSENT.pre_therapy_hipaa_full_sharing_benefits_description_text_2" | translate }}
                </p>
              </div>
            </div>

            <!-- A connected account -->
            <div class="hipaa-benefits-screen__item">
              <div class="hipaa-benefits-screen__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.206 19.194" fill="none" width="24" height="24">
                  <path d="M5.44125 1.53469C5.79375 1.18219 5.79375 0.612195 5.44125 0.263445C5.08875-0.0853049 4.51875-0.0890549 4.16625 0.259695L0.26625 4.15969C-0.08625 4.51219-0.08625 5.08219 0.26625 5.43094L4.16625 9.33469C4.51875 9.68719 5.08875 9.68719 5.4375 9.33469C5.78625 8.98219 5.79 8.41219 5.4375 8.06344L3.075 5.70094H18.3038C18.8025 5.70094 19.2037 5.29969 19.2037 4.80094C19.2037 4.3022 18.8025 3.90094 18.3038 3.90094H3.075L5.4375 1.53844L5.44125 1.53469ZM13.7663 11.1347L16.1288 13.4972H0.9C0.40125 13.4972 0 13.8984 0 14.3972C0 14.8959 0.40125 15.2972 0.9 15.2972H16.1288L13.7663 17.6597C13.4138 18.0122 13.4138 18.5822 13.7663 18.9309C14.1188 19.2797 14.6888 19.2834 15.0375 18.9309L18.9413 15.0347C19.2938 14.6822 19.2938 14.1122 18.9413 13.7634L15.0413 9.85969C14.6888 9.50719 14.1188 9.50719 13.77 9.85969C13.4213 10.2122 13.4175 10.7822 13.77 11.1309L13.7663 11.1347Z" fill="#006DFF"/>
                </svg>
              </div>
              <div class="hipaa-benefits-screen__content">
                <h3 class="hipaa-benefits-screen__item-title">
                  {{ "HIPAA-CONSENT.pre_therapy_hipaa_full_sharing_benefits_title_3" | translate }}
                </h3>
                <p class="hipaa-benefits-screen__item-description">
                  {{ "HIPAA-CONSENT.pre_therapy_hipaa_full_sharing_benefits_description_text_3" | translate }}
                </p>
              </div>
            </div>

            <!-- More complete data -->
            <div class="hipaa-benefits-screen__item">
              <div class="hipaa-benefits-screen__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.2 16.8" fill="none" width="24" height="24">
                  <path d="M7.65 0.10875C7.41375-0.0187499 7.13625-0.03375 6.88875 0.06375C6.64125 0.16125 6.45 0.3675 6.3675 0.61875L4.1475 7.40625H1.8V0.9C1.8 0.40125 1.39875 0 0.9 0C0.40125 0 0 0.40125 0 0.9V14.1C0 15.5925 1.2075 16.8 2.7 16.8H18.3C18.7988 16.8 19.2 16.3987 19.2 15.9C19.2 15.4012 18.7988 15 18.3 15H18V11.1C18 10.6012 17.5988 10.2 17.1 10.2C16.6013 10.2 16.2 10.6012 16.2 11.1V15H12.6V11.7C12.6 11.2012 12.1988 10.8 11.7 10.8C11.2013 10.8 10.8 11.2012 10.8 11.7V15H9V8.7C9 8.20125 8.59875 7.8 8.1 7.8C7.60125 7.8 7.2 8.20125 7.2 8.7V15H5.4V11.7C5.4 11.2012 4.99875 10.8 4.5 10.8C4.00125 10.8 3.6 11.2012 3.6 11.7V15H2.7C2.20125 15 1.8 14.5987 1.8 14.1V9.20625H4.8C5.19 9.20625 5.535 8.955 5.655 8.5875L7.74375 2.205L10.0088 3.4275L13.5975 10.605C13.7438 10.9012 14.04 11.0925 14.37 11.1037C14.7 11.115 15.0075 10.9462 15.1763 10.6612L16.74 8.01H18.3C18.7988 8.01 19.2 7.60875 19.2 7.11C19.2 6.61125 18.7988 6.21 18.3 6.21H16.2225C15.9038 6.21 15.6075 6.37875 15.4463 6.6525L14.4638 8.32125L11.49 2.36625C11.4075 2.20125 11.2762 2.06625 11.1112 1.97625L7.65 0.10875Z" fill="#006DFF"/>
                </svg>
              </div>
              <div class="hipaa-benefits-screen__content">
                <h3 class="hipaa-benefits-screen__item-title">
                  {{ "HIPAA-CONSENT.pre_therapy_hipaa_full_sharing_benefits_title_4" | translate }}
                </h3>
                <p class="hipaa-benefits-screen__item-description">
                  {{ "HIPAA-CONSENT.pre_therapy_hipaa_full_sharing_benefits_description_text_4" | translate }}
                </p>
              </div>
            </div>
          </div>

          <p class="hipaa-benefits-screen__footnote">
            {{ "HIPAA-CONSENT.pre_therapy_hipaa_full_sharing_benefits_footnote" | translate }}
          </p>

          <div class="c-form-field c-form-field--buttons c-form-field--buttons-wizard">
            <div class="c-form-field--buttons-wizard__back">
              <button class="c-btn c-btn--tertiary" type="button" (click)="onBack()">
                {{ 'ACCEPT-POLICIES.Back' | translate }}
              </button>
            </div>
            <div class="c-form-field--buttons-wizard__next">
              <button class="c-btn c-btn--primary" type="button" (click)="onReview()">
                {{ "HIPAA-CONSENT.pre_therapy_hipaa_full_sharing_benefits_primary_button_text" | translate }}
                <span class="hipaa-benefits-screen__review-arrow">&rarr;</span>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
